import keyMirror from 'keymirror';

export const TemplateFilters = keyMirror({
  active: null,
  archived: null,
});

export const TemplateFilterOptions = [
  {
    key: 'active',
    label: 'Active',
    value: TemplateFilters.active,
  },
  {
    key: 'archived',
    label: 'Archived',
    value: TemplateFilters.archived,
  },
];

/**
 * This mapping exists because originally, our experiences used the `.SquareColor--{n}` SCSS classes
 * (defined in dashboard/src/css/7-trumps/_square-colors.scss).
 *
 * Since then, we've:
 *   1) moved our styles to JSS/CSS-in-JS, and
 *   2) updated our experience colors.
 *
 * Things to note for the experience colors:
 * 1) They are set in a specific order so that adjacent experiences would have a decent amount of contrast
 *    (blue -> yellow -> orange for the first 3 experiences listed, for example).
 * 2) The last 6 colors are repeated because we originally had 15 experience colors,
 *    but Design intentionally wanted to stop after 10 colors, as very few customers
 *    actually have >10 experiences in any given business.
 */
export { ExperienceColors } from '@tock/shared/constants/ExperienceColors';

/**
 * ~~After launching EXPERIENCE_CUSTOM_COLORS for all of Dashboard, the above color set can be removed.~~
 *
 * Still used by:
 * - dashboard `ExperienceColorMapContext` to assign fallback colors for inventory squares
 * - clowncar rebalancer views (`rebalancerUtils` / `RebalancePlanComparisonDetail`)
 *
 * This array contains the unique values from the legacy square color set above.
 */
export const availableExperienceColors = [
  '#00c2e0',
  '#ffc246',
  '#faa484',
  '#66db32',
  '#f26d99',
  '#00e6b0',
  '#c472ff',
  '#e6d996',
  '#d0e0dd',
  '#c8bec8',
];

/**
 * Color to be used for archived experiences in place of ticketTypeDetails.displayColor
 */
export const archivedExperienceColor = '#8490a4';

export const ExperienceFilters = keyMirror({
  active: null,
  archived: null,
});

export type ExperienceFilter = 'active' | 'archived';

export const ExperienceFilterOptions = [
  {
    key: 'active',
    label: 'Active',
    value: ExperienceFilters.active,
  },
  {
    key: 'archived',
    label: 'Archived',
    value: ExperienceFilters.archived,
  },
];

export const EventFilterOptions = [
  {
    key: 'active',
    label: 'Upcoming',
    value: ExperienceFilters.active,
  },
  {
    key: 'archived',
    label: 'Past/Archived',
    value: ExperienceFilters.archived,
  },
];

export const HD_CLIENT_THRESHOLD = 1025;
